// extracted by mini-css-extract-plugin
export default {"header":"App_header__fhC8n","navigation":"App_navigation__ndhIK","wrapper":"App_wrapper__Mru9Z"};